export default __webpack_public_path__ + "static/1-1976af2e9560aa592cfc74e5ed8ff9dc.gif";